import { ProductListItem } from "@components/product-list/product-list-item";

export default function AlgoliaSearchResultItem({ hit }: { hit: any }) {
  const variants =
    Array.isArray(hit?.cardSize) && hit.cardSize.length > 0
      ? hit.cardSize.map((size: string) => ({
          ean: hit?.ean,
          catalogImgUrl: hit?.image,
          defaultVariant: true,
          targetPrice: hit?.minVariantTargetPrice,
          available: true,
          size,
        }))
      : [
          {
            ean: hit?.ean,
            catalogImgUrl: hit?.image,
            defaultVariant: true,
            targetPrice: hit?.minVariantTargetPrice,
            available: true,
            size: hit?.size,
          },
        ];

  const product = {
    id: hit?.objectID.split("-")[0],
    title: hit?.titleIt,
    brand: hit?.brand,
    minVariantTargetPrice: hit?.minVariantTargetPrice,
    colorsNormalized: hit?.colorsNormalized,
    variants,
  };

  return <ProductListItem key={hit?.objectID} product={product} hit={hit} />;
}
